import { render, staticRenderFns } from "./RaffleRules.vue?vue&type=template&id=38b74559&scoped=true"
import script from "./RaffleRules.vue?vue&type=script&lang=js"
export * from "./RaffleRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b74559",
  null
  
)

export default component.exports